import React, { useState } from 'react';
import MDialog from '../../../components/controls/MDialog';
import { FormControlLabel, Grid, Stack, Switch, Typography, LinearProgress } from '@mui/material';
import RCBarChart from '../../../components/charts/recharts/rcBarChart';
import RCPieChart from '../../../components/charts/recharts/rcPieChart';
import { buildQueryString, dataProvider } from '../../../DataProvider';

interface IData {
    [key: string]: any;
}

const ChartView: React.FC<IData> = (props) => {
    const { chart, setChart } = props;
    const filter = chart.filterList;
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = useState<any[]>([]);

    React.useEffect(() => {
        setIsLoading(true);
        dataProvider.fetchData('OrderMistakeReport', `ViewChart/Filter${convertFilter(filter)}`
        ).then((result: any) => {
            setData(convertData(result.data));
        }).catch((err: any) => {
            console.log(`Fail to fetch data: ${err}`, { type: 'error', autoHideDuration: 2000 });
        }).finally(_ => setIsLoading(false));
    }, []);

    const convertFilter = (filter: any) => {
        let _filter = buildQueryString({ filter: filter }, { orderBy: 'reported_date desc' });
        return _filter;
    };

    const convertData = (data: any) => {
        let newData: any[] = [];
        data = data.map((user: any) => ({ ...user, firstName: user.firstName || 'unname' })).sort((a: any, b: any) => a.firstName.localeCompare(b.firstName));
        let users = Object.groupBy(data, ({ receiver }: any) => receiver);

        Object.keys(users).forEach(item => {
            let major = users[item].filter((x: any) => x.error_level === 1).length;
            let minor = users[item].filter((x: any) => x.error_level === 0).length;
            let total = users[item].length;
            newData.push({
                name: users[item][0].firstName,
                major: major,
                minor: minor,
                unknown: total - major - minor,
            });
        });
        return newData;
    };
    return (
        <>
            <MDialog
                maxWidth={'xl'}
                open={chart.open}
                handleClose={() => setChart(prev => ({ ...prev, open: false, type: 'bar' }))}
                name={'order-mistake-dialog'}
                action={
                    <Stack direction="row" justifyContent={'space-between'} width="100%">
                        <FormControlLabel
                            value="pie"
                            control={<Switch color="primary" onChange={(ev) => setChart(prev => ({ ...prev, type: ev.target.checked ? 'pie' : 'bar' }))} />}
                            label="Pie chart"
                            labelPlacement="start"
                        />
                    </Stack>
                }
                children={
                    <>
                        {isLoading === true && <LinearProgress color='secondary' />}
                        <Typography sx={{ marginBottom: '10px' }} variant="h3" textAlign={'center'}>Order Mistake Chart</Typography>
                        {data.length && chart.type === 'bar' &&
                            (<RCBarChart
                                width={1500}
                                data={data}
                                barSize={data.length > 18 ? 50 : ((data.length > 8) ? 70 : 90)}
                                yGap={5}
                                xAxis={{ dataKey: 'name', label: { value: 'USER', dy: 20 } }}
                                yAxis={{ position: 'insideLeft', label: { value: 'Error Level', angle: -90, dx: -10 } }}
                                legend={{ verticalAlign: 'top', height: 60, iconType: 'square' }}
                                showTotal={true}
                                seriesList={[
                                    { dataKey: 'major', name: 'Major', fill: '#f44336', stackId: 'a', labelList: { fill: 'white' } },
                                    { dataKey: 'minor', name: 'Minor', fill: '#ff7400', stackId: 'a', labelList: { fill: 'white' } },
                                    { dataKey: 'unknown', name: 'Unknown', fill: '#808080', stackId: 'a', labelList: { fill: 'white' } },
                                ]}
                            >
                            </RCBarChart>)
                            ||
                            (
                                <Grid container alignItems="center" sx={{ minHeight: '65vh' }}
                                    justifyContent="center" spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                                    <RCPieChart
                                        data={data}
                                        dataKey={'name'}
                                        height={220}
                                        width={450}
                                        chartSize={80}
                                        elevation={20}
                                        seriesList={[
                                            { dataKey: 'major', name: 'Major', fill: '#f44336' },
                                            { dataKey: 'minor', name: 'Minor', fill: '#ff7400' },
                                            { dataKey: 'unknown', name: 'Unknown', fill: '#808080' },
                                        ]}
                                    >
                                    </RCPieChart>
                                </Grid>
                            )
                        }
                    </>
                }
            >
            </MDialog>
        </>
    );
};
export default ChartView;